$(document).ready(function () {
//***** disable 1pc variant & select 10pc/10pcs: Related Products Block (on Single Product Page) *****//

    // Function to handle the "10 pc" OR "10pcs" variant selection
    function relatedProducts_makeTenPieceVariantTheDefault() {
        $('body.page-product .js.product-form__input input:radio[name="Quantity"]').filter('[value="1 pc"]').removeAttr('checked');
        $('body.page-product .js.product-form__input input:radio[name="Quantity"]').filter(function() {
          return $(this).val().match(/^10\s?pcs?$/); 
        }).click();
        console.log("10pcs variant in 'Related Product items' selected on pageLoad.");
    }

    // Use MutationObserver to monitor class changes on the .related-products element
    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if ($(mutation.target).hasClass('product-recommendations--loaded')) {
                // When the "product-recommendations--loaded" class is detected

                // Make the "10 pc" variant the default selection
                relatedProducts_makeTenPieceVariantTheDefault();

                // Stop observing since the desired class has been applied
                observer.disconnect();
            }
        });
    });

    // Target the element with class "related-products"
    const targetElement = document.querySelector('.related-products');

    if (targetElement) {
        // Configure observer to watch for class attribute changes
        observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
    } else {
        //console.error('Element with class "related-products" not found.');
    }
});


/* Registration page: override Shopify Forms' useless implementation of the registration form and override CSS via JS by manipulating the 'shadow DOM'... */
document.addEventListener('DOMContentLoaded', () => {
  // Use a MutationObserver to wait for the form element to load before doing anything
  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector('form-embed#app-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      // Disconnect the observer once the form is found
      observer.disconnect();

      // Access the Shadow DOM
      const shadow = formEmbed.shadowRoot;

      // Create a new CSS StyleSheet to override the "constructed stylesheet" created by "Shopify Forms" in the Shadow DOM
      const sheet = new CSSStyleSheet();

      // insert basic button styled and override the shadow DOM of "Shopify Forms"
      sheet.insertRule(`
        button[data-testid="btn-form-submit"] {
          opacity: 1 !important;
          height: 40px !important;
          border-radius: 20px !important;
          text-transform: uppercase !important;
          font-weight: 500 !important;
          font-size: 16px;
          padding: 0px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: opacity 0.3s ease-in-out !important;
          filter: none !important;
        }
      `);

      // insert CSS for the Hover state into the shadow DOM
      sheet.insertRule(`
        button[data-testid="btn-form-submit"]:hover {
          opacity: 0.8 !important;
          transition: opacity 0.3s ease-in-out !important;
          filter: none !important;
        }
      `);

      // Add @media query for screens up to 1199px intop the shadow DOM
      sheet.insertRule(`
        @media screen and (max-width: 1199px) {
          button[data-testid="btn-form-submit"] {
            font-size: 14px !important;
            line-height: 18px !important;
          }
        }
      `);

      // Apply the custom styles to the Shadow DOM
      shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];

      console.log('Custom styles applied to the form.');
    }
  });

  // Start observing changes in the DOM
  observer.observe(document.body, { childList: true, subtree: true });
});